var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 805.511,
    height: 82.202,
    viewBox: "0 0 805.511 82.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "id_101",
    d: "M544.86,78.65h3.949L544.86,83.78l3.949-5.131h0c154-.684,246.653-13.78,246.653-29.8S632.342,19.8,478.341,19.116v-.065l-190.062-.627L100.7,19.051H84.641l82.929,8.536c9.793,1.008,9.793,2.656,0,3.664s-20.631-2.656-30.425-3.664L7.351,18.424c-5.06-.521-7.376-1.21-7.225-1.9-.176-.687,2.165-1.376,7.225-1.9L137.146,5.467C146.939,4.46,157.777.8,167.571,1.8s9.793,2.656,0,3.664l-81.62,8.4H478.341c1.485,0,2.744.062,4.154.088,179.882.9,323.132,16.156,323.132,34.894,0,19.32-73.056,34.93-260.767,34.93-3.4,0,3.4.01,0,0h0v.052l.293-.052c-13.847,0-2.492-2.472-2.492-3.9S548.8,78.645,544.86,78.65Z",
    transform: "translate(-0.117 -1.63)",
    fill: "#ececec",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/Arrow left.a5c7e4de13977246ec74ef781f645931.svg";
export { ForwardRef as ReactComponent };